import styled from 'styled-components';

export const CircleButtonContainer = styled.div`
	position: absolute;
	right: -4px;
	bottom: 19px;
`;

export const IconButtonContainer = styled.div`
	position: relative;
`;
